import React from 'react';
import { RecentEvent } from '../RecentEvent.interface';
import { environments } from 'environments/environments';
import PhotoDisplay from 'libs/components/PhotoDisplay/PhotoDisplay';
import './Poster.css';
import { GalleryImage } from 'components/Main/PhotoSection/Gallery.interface';

interface Props { image: RecentEvent }
interface State { [key: string]: any }

export default class Poster extends React.Component<Props, State> {
  state = {
    posterDisplayed: false
  }

  openImage() {
    this.setState({ posterDisplayed: true })
  }

  closeImage() {
    this.setState({ posterDisplayed: false });
  }

  render() {
    // console.log(this.props);
    const image: GalleryImage = {
      category: 'poster',
      filename: this.props.image.poster,
      gallery: 0,
      width: this.props.image.posterWidth || 0,
      height: this.props.image.posterHeight || 0,
      id: 0,
      order: 0,
      public: 1,
      text: '',
      time: Date.now()
    }
    return (
      <div className="poster">
        <img src={`${environments.server}/${this.props.image.poster}`} alt="Pozvánka na nejbližší akci" onClick={() => this.openImage()} />
        { this.state.posterDisplayed
          ? <PhotoDisplay activePhoto={0} photoList={[image]} close={this.closeImage.bind(this)} />
          : null
        }
      </div>
    );
  }
}